export const goAuthExample = `package main

import (
	"bytes"
	"crypto/hmac"
	"crypto/sha256"
	"encoding/hex"
	"encoding/json"
	"fmt"
	"io/ioutil"
	"net/http"
	"os"
	"time"

	"github.com/google/uuid"
)

// API authentication details
var (
	APIKey       = os.Getenv("VENDOR_API_KEY")
	WebhookSecret = os.Getenv("VENDOR_WEBHOOK_SECRET")
	VendorID     = os.Getenv("VENDOR_ID")
)

// Generate HMAC signature for the payload
func generateSignature(payload []byte, secret string) (string, error) {
	h := hmac.New(sha256.New, []byte(secret))
	_, err := h.Write(payload)
	if err != nil {
		return "", err
	}
	return hex.EncodeToString(h.Sum(nil)), nil
}

// Submit data using dual authentication
func submitData(testData map[string]interface{}) (map[string]interface{}, error) {
	endpoint := "https://app.reasonshield.com/api/v1/lis-webhook/vendor/submit-data"
	
	// Create full request payload
	payload := map[string]interface{}{
		"vendor_id":  VendorID,
		"timestamp":  time.Now().UTC().Format(time.RFC3339),
		"request_id": uuid.New().String(),
		"test_data":  testData,
	}
	
	// Marshal payload to JSON for request body
	// Ensure consistent ordering for signatures
	jsonBytes, err := json.Marshal(payload)
	if err != nil {
		return nil, fmt.Errorf("error marshaling payload: %v", err)
	}
	
	// Generate signature
	signature, err := generateSignature(jsonBytes, WebhookSecret)
	if err != nil {
		return nil, fmt.Errorf("error generating signature: %v", err)
	}
	
	// Create HTTP request with dual authentication
	req, err := http.NewRequest("POST", endpoint, bytes.NewBuffer(jsonBytes))
	if err != nil {
		return nil, fmt.Errorf("error creating request: %v", err)
	}
	
	// Set headers with both authentication methods
	req.Header.Set("Content-Type", "application/json")
	req.Header.Set("Authorization", "Bearer "+APIKey)        // API Key Authentication
	req.Header.Set("X-Vendor-Signature", signature)          // Signature Verification
	
	// Send request
	client := &http.Client{}
	resp, err := client.Do(req)
	if err != nil {
		return nil, fmt.Errorf("error sending request: %v", err)
	}
	defer resp.Body.Close()
	
	// Read response body
	body, err := ioutil.ReadAll(resp.Body)
	if err != nil {
		return nil, fmt.Errorf("error reading response: %v", err)
	}
	
	// Check status code
	if resp.StatusCode != 200 {
		return nil, fmt.Errorf("API request failed with status %d: %s", 
		    resp.StatusCode, string(body))
	}
	
	// Parse response
	var result map[string]interface{}
	if err := json.Unmarshal(body, &result); err != nil {
		return nil, fmt.Errorf("error parsing response: %v", err)
	}
	
	return result, nil
}

func main() {
	// Example test data
	testData := map[string]interface{}{
		"test_id":    "12345",
		"panel_type": "RESPIRATORY",
	}
	
	// Submit data with dual authentication
	result, err := submitData(testData)
	if err != nil {
		fmt.Printf("Error: %v\n", err)
		return
	}
	
	fmt.Printf("Data submitted successfully: %v\n", result)
}`; 